import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function PurchaseConfirmation() {
  return <section className="relative overflow-hidden bg-[#FDF8F3] py-12 px-4" data-id="element-35">
      <div className="relative max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-36">
        <motion.div initial={{
        scale: 0,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.5,
        type: 'spring',
        stiffness: 200
      }} className="mb-6" data-id="element-37">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-2" data-id="element-38">
            <CheckCircleIcon className="w-10 h-10 text-green-600" aria-hidden="true" data-id="element-39" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#3D2C2C] mb-8 font-heading" data-id="element-40">
          ¡Tu compra fue confirmada!
        </motion.h1>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="w-full max-w-md mx-auto mb-8" data-id="element-41">
          <img src="https://cdn.magicpatterns.com/uploads/wXWWws5umYjPER3isKfHzc/20260225_1731_Image_Generation_simple_compose_01kjb7zbkpetat25nqp9xr0xsh_(1).png" alt="Mega Colección +60 Patrones Amigurumis de Mascotas" className="w-full h-auto object-contain rounded-xl shadow-lg" data-id="element-42" />
        </motion.div>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-lg md:text-xl text-[#5A4A4A] max-w-xl mx-auto leading-relaxed mb-6" data-id="element-43">
          Acabas de adquirir la Mega Colección +60 Patrones Amigurumis de
          Mascotas con todos los bonos incluidos.
        </motion.p>

        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="text-[#C17F3E] font-semibold text-lg" data-id="element-44">
          ⬇ Tu descarga estará lista al final de esta página.
        </motion.div>
      </div>
    </section>;
}